<template>
    <v-app>
        <core-drawer />
        <v-main class="overflow-hidden">
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'App',

    components: {
        CoreDrawer: () => import('@/components/core/Drawer'),
    },
};
</script>

<style>
.text-decoration-none {
    text-decoration: none;
}
</style>
